import React from 'react';
import { Button, VStack, Text, Box, useColorModeValue, HStack, Tooltip, Icon } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function EquipmentSelector({
  onSelect,
  selected,
  equipmentList,
  isOpen,
  targetUserId,
  showEstimateButton = true,
  fixedMap = {}
}) {
  const { currentUser, isFunctionEnabled } = useAuth();
  const equipmentItems = equipmentList.equipment_types;

  if (isOpen) {
    return (
        <VStack spacing={2} align="stretch">
          {Object.entries(equipmentItems || {}).map(([key, eq]) => {
            const isSelected = selected == key;
            const hasSelectedItems = fixedMap[key] === true;
            return (
              <Tooltip 
                label={
                  eq.hover_text || 
                  (eq.name === 'キッチン' ? 'キッチンの種類やサイズを選択できます' :
                   eq.name === '浴室' ? '浴室のタイプやサイズを選択できます' :
                   eq.name === '洗面台' ? '洗面台の種類やサイズを選択できます' :
                   eq.name === 'トイレ' ? 'トイレの種類や機能を選択できます' :
                   eq.name === '間取り' ? '間取り図面を選択できます' :
                   `${eq.name}の種類やサイズを選択できます`)
                }
                hasArrow 
                placement="right" 
                key={key}
              >
                <Box position="relative">
                  <Button
                    onClick={() => eq.enabled ? onSelect(key) : alert('現在開発中')}
                    bg="gray.50"
                    color="black"
                    fontWeight={isSelected ? 'bold' : 'normal'}
                    cursor={eq.enabled ? 'pointer' : 'not-allowed'}
                    mb={2}
                    w="100%"
                    fontSize="1.1em"
                    borderRadius="md"
                    boxShadow={eq.enabled ? 'sm' : 'none'}
                    transition="background 0.2s"
                    position="relative"
                    justifyContent="flex-start"
                    textAlign="left"
                    _active={eq.enabled ? { bg: isSelected ? 'white' : 'white' } : {}}
                  >
                    {eq.name}
                  </Button>
                  {/* 概算見積アイテムがある場合のチェックマークオーバーレイ */}
                  {hasSelectedItems && (
                    <Box
                      position="absolute"
                      top="0"
                      left="0"
                      right="0"
                      bottom="2px"
                      bg="rgba(0, 0, 0, 0.03)"
                      borderRadius="md"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      pointerEvents="none"
                      zIndex={1}
                    >
                      <Icon 
                        as={CheckIcon} 
                        boxSize="16px" 
                        color="gray.400"
                        opacity={0.5}
                      />
                    </Box>
                  )}
                </Box>
              </Tooltip>
            );
          })}
          
          {/* 概算見積リンク - showEstimateButtonがtrueの場合のみ表示 */}
          {showEstimateButton && (
            <Box mt={4}>
              <Button
                as={RouterLink}
                to={targetUserId ? `/admin/user/${targetUserId}/equipment/confirmed-summary` : '/equipment/confirmed-summary'}
                size="sm"
                bg="gray.700"
                color="white"
                _hover={{ bg: 'gray.800' }}
                _active={{ bg: 'gray.900' }}
                width="100%"
                fontWeight="bold"
                borderRadius="md"
                boxShadow="md"
              >
                概算見積
              </Button>
            </Box>
          )}
        </VStack>
    );
  }
  
  // サイドバーが閉じられた状態では縦文字で「設備・建材を選択」を表示
  return (
    <Tooltip 
      label="設備・建材の種類を選択できます" 
      hasArrow 
      placement="right"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        h="100%"
        pt={2}
        cursor="pointer"
        onClick={() => onSelect(selected)}
      >
        <VStack spacing={0} color="gray.600" fontSize="xs">
          <Text>設</Text>
          <Text>備</Text>
          <Text>・</Text>
          <Text>建</Text>
          <Text>材</Text>
          <Text>を</Text>
          <Text>選</Text>
          <Text>択</Text>
        </VStack>
      </Box>
    </Tooltip>
  );
}